import React, { useState, useEffect } from "react";
import DataTable from "../../components/Table";
import { downloadPSMLogs, getPSMLogs } from "../../store/actions/psmAction";
import { useDispatch } from "react-redux";
import { convertDateInFormat, formateDate } from "../../utils/utils";
import MobilePopUp from "../../components/MobilePopUp/MobilePopUp";
import Calendar from "../../components/Calendar/Calendar";

const PSMLogs = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [interactionId, setInteractionId] = useState("");
  const [psmLogsData, setPsmLogsData] = useState([]);
  const [showLogsDate, setShowLogsDate] = useState(false);
  const [logsDate, setLogsDate] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    callPSMLogsApi();
  }, []);

  const callPSMLogsApi = async () => {
    const payload = {
      size: pageSize,
      page: currentPage,
      searchKey: interactionId,
      date: logsDate ? convertDateInFormat(logsDate, "YYYY-MM-DD") : null,
    };
    const resp = await dispatch(getPSMLogs(payload));
    if (resp?.data) {
      setPsmLogsData(resp?.data);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    callPSMLogsApi();
  };

  const handleRowClick = async (row) => {
    const payload = {
      fileName: row.fileName,
      proposalNumber: "1234567890",
      folderType: "PSMLogs",
    };

    await dispatch(downloadPSMLogs(payload));
  };

  return (
    <div className="operations-page__psm-logs">
      <form
        className="operations-page__panel operations-page__form"
        onSubmit={handleSearch}
      >
        <div className="operations-page__compact-grid">
          <div className="operations-page__field">
            <label className="operations-page__label" htmlFor="psm-interaction">
              Interaction ID
            </label>
            <input
              id="psm-interaction"
              onChange={(e) => setInteractionId(e.target.value)}
              value={interactionId}
              className="operations-page__input"
              type="text"
              placeholder="Enter interaction ID"
              name="interactionId"
            />
          </div>
          <div className="operations-page__field">
            <label className="operations-page__label">Log creation date</label>
            <div
              className="operations-page__date-input"
              onClick={() => setShowLogsDate(true)}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  setShowLogsDate(true);
                }
              }}
            >
              <span
                className={`operations-page__date-value ${
                  logsDate ? "active" : ""
                }`}
              >
                {logsDate ? formateDate(logsDate) : "DD/MM/YYYY"}
              </span>
              <span className="calendar_icon" />
            </div>
            {showLogsDate && (
              <MobilePopUp
                hideCloseBtn={true}
                removeHeader={true}
                cssClass="daterange-mobilepopup"
              >
                <Calendar
                  dob=""
                  maxDate={new Date()}
                  onCancel={() => {
                    setShowLogsDate(false);
                    setLogsDate(null);
                  }}
                  onApply={(sd) => {
                    setShowLogsDate(false);
                    setLogsDate(new Date(sd));
                  }}
                />
              </MobilePopUp>
            )}
          </div>
        </div>
        <div className="operations-page__actions">
          <button
            type="submit"
            className="operations-page__btn operations-page__btn--primary"
          >
            Search
          </button>
        </div>
      </form>

      <div className="proposal-dashboard__table-section operations-page__table-section operations-page__psm-logs-table">
        {psmLogsData && psmLogsData?.length > 0 ? (
          <DataTable
            cellHeaders={["File name"]}
            keys={["fileName"]}
            data={psmLogsData}
            fileName="PSM-Logs"
            showExcelDownload={false}
            PerPageApiData={false}
            paginationItems={psmLogsData}
            alwaysShown={false}
            onRowClick={handleRowClick}
            clickColumnIndex={0}
            setCurrentPage={setCurrentPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            rowCustomCss="operations-page__clickable-link"
          />
        ) : (
          <div className="operations-page__no-data">No record found</div>
        )}
      </div>
    </div>
  );
};

export default PSMLogs;
